import { LucideTrash2 } from "lucide-react";
import { Button } from "../../../../../../shared/components/button/Button";

const ObjectivesTrackerDeleteButton = ({ onDeleteHandler }) => {
  return (
    <Button
      aria-haspopup="true"
      size="icon"
      variant="ghost"
      onClick={onDeleteHandler}
    >
      <LucideTrash2 className="h-4 w-4" />
      <span className="sr-only">Toggle menu</span>
    </Button>
  );
};

export default ObjectivesTrackerDeleteButton;
